<template>
  <div class="search-wrapper">
    <input
        type="text"
        class="search-input"
        v-model="query"
        :placeholder="$t('PLACEHOLDER.Search')"
    >
    <button-component variant="icon" class="search-button" :disabled="!query">
      <search-icon/>
    </button-component>
  </div>
</template>

<script>
import ButtonComponent from './buttons/ButtonComponent';
import SearchIcon from '../../assets/img/searchIcon';
import {debounce} from 'lodash';

export default {
  name: 'SearchField',
  components: {SearchIcon, ButtonComponent},
  data() {
    return {
      query: '',
    };
  },
  methods: {
    emit() {
      this.$emit('search', this.query);
    },
  },
  computed: {
    throttledEmit() {
      return debounce(this.emit, 1000);
    },
  },
  watch: {
    query() {
      this.throttledEmit();
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/css/colors";

.search-wrapper {
  border: 1px solid var(--settings-event-card-text-color);
  border-radius: 0.5rem;
  gap: 1px;
  padding: 3px;
  display: flex;
  gap: 1rem;
}

.search-button {
  width: 2rem;
  height: 2rem;
  padding: .25rem;
  box-sizing: border-box;
  color: $text-primary;

  &:disabled {
    color: $text-tertiary-middle;
    background: transparent;
  }
}

.search-input {
  outline: none;
  border: none;
  padding: 0 2rem;
  background: transparent;
  width: 100%;
  color: var(--settings-body-text-color);
}

</style>
